const FixedIds = {
  idHenrique: process.env.NODE_ENV === 'development' ? 2017 : 2,
  idBruno: process.env.NODE_ENV === 'development' ? 3051 : 5,
  idMarcio: process.env.NODE_ENV === 'development' ? 3052 : 3643,
  idPedro: process.env.NODE_ENV === 'development' ? 2008 : 1015,
  idRenan: process.env.NODE_ENV === 'development' ? 3046 : 2183,
  idDanielRaupp: process.env.NODE_ENV === 'development' ? 3047 : 1033,
  idLucas: process.env.NODE_ENV === 'development' ? 3037 : 4,
  // -- ids para Processo de assistência técnica --
  ticketTypeFalhaHardware: process.env.NODE_ENV === 'development' ? 13 : 2,
  ticketStatusAguardandoAssistenciaTecnica: process.env.NODE_ENV === 'development' ? 2016 : 1020,
  ticketStatusConcluido: process.env.NODE_ENV === 'development' ? 2017 : 1006,
  ticketCauseDefeito: process.env.NODE_ENV === 'development' ? 2 : 5,
  ticketSolutionTypeDefinitiva: process.env.NODE_ENV === 'development' ? 1 : 1,
  techAssisOriginSuporte: process.env.NODE_ENV === 'development' ? 2 : 8,
  idUsuarioAtribuidoTechAssis: process.env.NODE_ENV === 'development' ? 2017 : 1016, // prod poa, dev henrique
  // -- ids techAssis status
  techAssisStatusAguardandoEnvio: process.env.NODE_ENV === 'development' ? 2018 : 1021,
  techAssisProductReceivedStatus: process.env.NODE_ENV === 'development' ? 2002 : 5,
  techAssisStatusInProgress: process.env.NODE_ENV === 'development' ? 2021 : 2,
  techAssisStatusWaitingApproval: process.env.NODE_ENV === 'development' ? 2022 : 3,
  techAssisStatusApprovedCompleted: process.env.NODE_ENV === 'development' ? 2023 : 6,
  techAssisStatusNotApproved: process.env.NODE_ENV === 'development' ? 1003 : 1004,
  techAssisStatusWithoutRepair: process.env.NODE_ENV === 'development' ? 1002 : 1005,
  techAssisStatusCanceled: process.env.NODE_ENV === 'development' ? 2026 : 1039,
  techAssisStatusCanceledExpired: process.env.NODE_ENV === 'development' ? 2027 : 1043,
  // -- ids para Processo de assistência técnica --
  taskStatusPauseTempId: process.env.NODE_ENV === 'development' ? 2014 : 1028,
  // -- ids para Prod. Eng. --
  prodEndTicketStatusId: process.env.NODE_ENV === 'development' ? 1 : 1019,
  prodEndTicketOriginId: process.env.NODE_ENV === 'development' ? 2 : 6,
  // -- ids para Prod. Eng. --
  ticketStatusFila: process.env.NODE_ENV === 'development' ? 2025 : 1003,
  ticketTypeProposalForImprovementOfExistingFunctionality: process.env.NODE_ENV === 'development' ? 21 : 2023,
  ticketStatusDesenvolvidoAnalisado: process.env.NODE_ENV === 'development' ? 2024 : 1009,
  finalCustomerCommboxId: process.env.NODE_ENV === 'development' ? 9 : 1048,
  lanzabotId: process.env.NODE_ENV === 'development' ? 2018 : 3449,
  // -- ids para Prod. Eng. minhas solicitações --
  resolutionTicketStatusId: process.env.NODE_ENV === 'development' ? 2015 : 1008,
  departmentIdSoftware: process.env.NODE_ENV === 'development' ? 2 : 1012,
  departmentIdSoftwareBacklog: process.env.NODE_ENV === 'development' ? 1018 : 1023,
};

export default FixedIds;